export enum AcademyRegistrationRequestStatus {
    /** 요청 대기 */
    Pending = 0,
    /** 요청 승인*/
    Approved = 1,
    /** 요청 거부 */
    Rejected = 2,
    /** 요청 취소 */
    Canceled = 3,
}
